import { z } from 'zod';
import { UserIdSchema } from './users';
import { AccountIdSchema } from './accounts';
export var TeamIdSchema = z.coerce.number();
export var TeamSchema = z.object({
    id: TeamIdSchema,
    user_ids: z.array(UserIdSchema),
    account_id: AccountIdSchema,
    team_name: z.string(),
    // TODO: Solidify these type checks against input without coercion or optionality
    is_all_players_team: z.coerce.boolean(),
    upload_url: z.string().nullable().optional(),
    add_time: z.string(),
    update_time: z.string(),
    deactivated: z.coerce.boolean()
});
